import React from "react";

const ErrorMessage = ({ error }) => {
  return error ? <p>{error.message.toString()}</p> : null;
};

export default ErrorMessage;
